import * as THREE from "three";
import { disposeO3D } from '../js/threejsHelper';
let group_openspaceGoal = null;
let visible_openspaceGoal = true;
let material_dian = new THREE.MeshBasicMaterial({ color: 0x145b7d })

export const clear_planning_result = () => {
    disposeO3D(group_openspaceGoal);
    group_openspaceGoal = null
}

export const render_planning_result = (vehicleData, scene, origin) => {
    try {
        render_openspaceGoal(vehicleData, scene, origin)
    } catch (error) {
        console.log(error);
    }
}

const render_openspaceGoal = (vehicleData, scene, origin) => {
    let openspaceGoal = null;
    if (vehicleData?.planning?.openspaceGoal) {
        openspaceGoal = vehicleData?.planning?.openspaceGoal
    }
    if (openspaceGoal && visible_openspaceGoal) {
        if (group_openspaceGoal) {
            group_openspaceGoal.children?.forEach((v) => {
                disposeO3D(v)
            })
        } else {
            group_openspaceGoal = new THREE.Group();
            scene.add(group_openspaceGoal);
        }
        build_openspaceGoal(openspaceGoal);
        group_openspaceGoal.deleteFalg = 10;
        group_openspaceGoal.position.set(openspaceGoal.position.x, openspaceGoal.position.y, 0);
    } else {
        if (group_openspaceGoal) {
            group_openspaceGoal.deleteFalg--;
            if (group_openspaceGoal.deleteFalg < 0) {
                group_openspaceGoal.children.forEach((v) => {
                    disposeO3D(v)
                })
            }
        }
    }
}
function build_openspaceGoal(openspaceGoal) {
    {
        //椎体
        // const geometry = new THREE.ConeGeometry(0.2, 1, 32)
        const geometry = new THREE.ConeGeometry(0.5, 2, 32)
        material_dian.opacity = 1
        material_dian.transparent = true
        const cone = new THREE.Mesh(geometry, material_dian)
        cone.up = new THREE.Vector3(0, 0, 1)
        cone.rotation.set(Math.PI / 2, 0, Math.PI)
        cone.position.set(0, 0, 1)
        group_openspaceGoal.add(cone)
    }
    {
        let arrow = createArrowHelper(openspaceGoal.heading);
        group_openspaceGoal.add(arrow)
    }
}

function createArrowHelper(rotationZ) {
    let x_end = Math.cos(rotationZ) * 2;
    let y_end = Math.sin(rotationZ) * 2;
    const dir = new THREE.Vector3(x_end, y_end, 0);
    dir.normalize();
    const origin = new THREE.Vector3(0, 0, 0);
    const length = 3;
    const hex = 0x1d953f;
    const arrowHelper = new THREE.ArrowHelper(dir, origin, length, hex);
    arrowHelper.position.set(0, 0, 2.5)
    return arrowHelper;
}
